import { useEffect, useState } from 'react';

import { SelectOptionType } from '@/shared/config';
import { debug } from '@/shared/lib';

import { getAvailableLanguages } from '../lib/getAvailableLanguages';

type Languages = Record<string, string[]>;

const getLanguages = async (): Promise<Languages> =>
  import('localizations').then((localizations) => localizations.languages);

export const transformLanguages = (languages: Languages) =>
  Object.keys(languages).map((langKey) => {
    const [, languageNativeName] = languages[langKey];
    return {
      value: langKey,
      label: languageNativeName,
    };
  });

// hook returns two arrays because InviteSignup requires "languageOptions"
export const useLanguages = () => {
  const [languageOptions, setLanguageOptions] = useState<SelectOptionType[]>(
    [],
  );

  useEffect(() => {
    const fetchLanguages = async () => {
      try {
        const langs = await getLanguages();

        const availableLangs = getAvailableLanguages();

        const transformedLangs = transformLanguages(langs);

        const filteredByAvailabilityLangs = transformedLangs.filter(
          (langOption) => availableLangs.includes(langOption.value),
        );

        setLanguageOptions(filteredByAvailabilityLangs);
      } catch (error: unknown) {
        debug(error);
      }
    };

    fetchLanguages();
  }, []);

  return { languageOptions };
};
